import { Component, OnInit, Injector, Input } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'info-we-found',
	template: `
		<table class="outer" role="presentation">
			<tbody>
				<tr>
					<td class="col-left">
						<table class="inner" role="presentation">
							<tr>
								<td>
									<tooltip [tooltip]="control.tooltip" *ngIf="control.tooltip"></tooltip>

									<h2>{{ control.attributes.title }}</h2>

									<p class="subtitle">
										{{ getSubtitle() }}
									</p>
									<div class="btn-wrapper">
										<button
											class="editpencil"
											aria-label="Info We Found Edit"
											(click)="setAnswer(control.attributes.value); ajaxAction()"
											[disabled]="control.disabled"
											gtm-handler
											events="click"
											handlerType="dataValue"
											label="Info_We_Found_Edit"
											[value]="getStageName()"
											action="ButtonClick"
										></button>
									</div>
								</td>
							</tr>
						</table>
					</td>
					<td class="col-right">
						<i *ngIf="auditing && auditing.type === 'consumer'" class="icon icon-cog" (click)="ajaxAction()"></i>
						<button
							class="editpencil"
							aria-label="Info We Found Edit"
							name="{{ getNameAttribute() }}"
							(click)="onEditClick()"
							[disabled]="control.disabled"
							gtm-handler
							events="click"
							handlerType="dataValue"
							label="InfoWeFound_View_Section_Edit_Button"
							[value]="getStageName()"
							action="ButtonClick"
						></button>
					</td>
				</tr>
			</tbody>
		</table>
	`,
	styleUrls: ['./info-we-found.component.scss'],
})
export class InfoWeFoundComponent extends EventsComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		this.firePrefillDisplay();
	}

	getSubtitle() {
		return this.storeService.getDynamicContent(`InfoWeFound.${this.control.name}`);
	}

	getNameAttribute() {
		let str = this.control.name.split('found');
		if (str.length > 1) {
			return `${str[1]}.InfoWeFound.EditButton`;
		}
		return '';
	}

	getStageName() {
		return this.storeService.getState().data.ui.page.title;
	}

	onEditClick() {
		this.setAnswer(this.control.attributes.value);
		this.ajaxAction();
		this.splunkAnalyticsService.publish('ButtonClick', 'InfoWeFound_View_Section_Edit');
	}

	firePrefillDisplay() {
		if (this.control.prefillDisplay) {
			this.splunkAnalyticsService.pushDisplayOnce(
				`InfoWeFound_View_Displayed_${this.control.prefillDisplay.join('_').replace(/PolicyData./g, '')}`
			);
		}
	}
}
